import { gql } from '@lcs/shared/api';

export const getRolesQuery = gql`
   query GetRoles($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      rolesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            roleId
            name
            description
            account {
               accountId
               name
            }
            userRolesCount
         }
      }
   }
`;
